const withPreventDefault = <T extends MouseEvent | KeyboardEvent | TouchEvent>(
  e: T,
  p0?: (e: T) => void,
) => {
  e.preventDefault()
  e.stopPropagation()
  p0?.(e)
}

export default withPreventDefault
